import { createContext, useContext, useState, useEffect } from 'react';
import { IntlProvider } from 'react-intl';

import ptMessages from './locales/pt.json';
import enMessages from './locales/en.json';

const messages = {
  en: enMessages,
  pt: ptMessages,
};

export const LOCALES = ['pt', 'en'];

const IntlContext = createContext({ locale: 'pt', switchLanguage: () => {} });

export const useIntlContext = () => useContext(IntlContext);

export function IntlWrapper({ children }) {
  const [locale, setLocale] = useState('pt');

  useEffect(() => {
    const saved = localStorage.getItem('locale');
    if (saved && LOCALES.includes(saved)) {
      setLocale(saved);
    }
  }, []);

  // Keeps <html lang> honest for screen readers and crawlers.
  useEffect(() => {
    document.documentElement.lang = locale === 'en' ? 'en' : 'pt-BR';
  }, [locale]);

  // Takes the target language explicitly, so the buttons can't get out of sync.
  const switchLanguage = (next) => {
    if (!LOCALES.includes(next)) return;
    localStorage.setItem('locale', next);
    setLocale(next);
  };

  return (
    <IntlContext.Provider value={{ locale, switchLanguage }}>
      <IntlProvider locale={locale} messages={messages[locale]}>
        {children}
      </IntlProvider>
    </IntlContext.Provider>
  );
}
